import React, { Fragment } from "react";
import theme from "../../../../assets/theme";
import VideoBox from "../../../common/VideoBox";
import styled from "styled-components";

const Live = ({ url }) => {
  return (
    <Fragment>
      <OuterContainer>
        <Container>
          {url?.length
            ? url
                ?.filter((item) => item?.label === "Live Stream")
                .map((stream) => (
                  <VideoCard>
                    <VideoBox
                      src={
                        stream?.liveStreamPlayerUrl
                          ? stream?.liveStreamPlayerUrl
                          : ""
                      }
                    />
                  </VideoCard>
                ))
            : null}
        </Container>
      </OuterContainer>
    </Fragment>
  );
};

export default Live;

const VideoCard = styled.div`
  display: flex;
  margin: 18px 0;
  width: 100%;
  flex-direction: row;
  align-items: center;
  border-radius: 15px;
  @media${theme.breakpoints.sm_up} {
    width: 85%;
  }
  @media ${theme?.breakpoints?.lg_up} {
    align-items: space-between;
  }
`;

const OuterContainer = styled.div`
  // background: #ded9ff;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 30px;
`;

const Container = styled.div`
  border-radius: 11px;
  width: 100%;
  margin: 10px 0px;
  padding: 30px 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 600px) {
    width: 90%;
    padding: 30px 30px;
  }
  @media ${theme.breakpoints.sm_up} {
    width: 100%;
  }
`;
